import { css } from 'bumbag';
import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';

var _templateObject, _templateObject2;
var Container = {
  styles: {
    base: function base(props) {
      return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      ", ";\n    "])), props.isFluid && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n          margin: 0px;\n        "]))));
    }
  }
};

export default Container;
